import { render, staticRenderFns } from "./TicketState.vue?vue&type=template&id=84ce2cca&scoped=true&"
import script from "./TicketState.vue?vue&type=script&lang=js&"
export * from "./TicketState.vue?vue&type=script&lang=js&"
import style0 from "./TicketState.vue?vue&type=style&index=0&id=84ce2cca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ce2cca",
  null
  
)

export default component.exports